import { makeAutoObservable, runInAction } from 'mobx'
import { logger } from 'shared/lib'
import { SingletonRequest } from 'shared/api/lib'
import { IntegrationsApi, type IResponseIntegrationStateStatus } from 'entities/Integrations/api'

export class CalendlyIntegrationStateStore {
  private _calendlyStatus: IResponseIntegrationStateStatus | null = null

  constructor() {
    makeAutoObservable(this)
  }

  get calendlyStatus() {
    return this._calendlyStatus
  }

  private _fetchCalendlyIntegrationState = async () => {
    try {
      const response = await IntegrationsApi.getIntegrationCalendarState()

      runInAction(() => {
        this._calendlyStatus = response.data.external_organization?.status || null
      })
    } catch (e) {
      logger.error(e)
    }
  }

  fetchCalendlyIntegrationState = new SingletonRequest(this._fetchCalendlyIntegrationState).request
}
